import React, { useEffect, useState } from "react";
import PageLayout from "../../ui/PageLayout";
import PageHero from "../../ui/PageHero";
import FadeIn from "../../ui/FadeIn";

// Image Imports
import image1 from "../../../images/KU team 2025/Project 1/WhatsApp Image 2025-11-03 at 10.07.19 AM.jpeg";
import image2 from "../../../images/KU team 2025/Project 1/WhatsApp Image 2025-11-03 at 10.07.19 AM (1).jpeg";
import image3 from "../../../images/KU team 2025/Project 1/WhatsApp Image 2025-11-03 at 10.07.19 AM (2).jpeg";
import image4 from "../../../images/KU team 2025/Project 1/WhatsApp Image 2025-11-03 at 10.07.20 AM.jpeg";
import image5 from "../../../images/KU team 2025/Project 1/WhatsApp Image 2025-11-03 at 10.07.20 AM (1).jpeg";
import musoVideo from "../../../images/KU team 2025/Project 2/MuSo.mp4";

const DaanUtsav = () => {
  const [activeTab, setActiveTab] = useState("project1");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <PageLayout>
      <PageHero title="Daan Utsav - 2025" eyebrow="India's Festival of Giving" light />
      
      <section className="ku-section bg-white py-12">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 space-y-12">
          
          {/* Tabs Navigation */}
          <div className="flex flex-col sm:flex-row justify-center items-center gap-4 sm:gap-8 border-b border-gray-200 pb-4">
            <button
              onClick={() => setActiveTab("project1")}
              className={`text-lg font-bold transition-all duration-300 pb-2 border-b-4 ${
                activeTab === "project1"
                  ? "text-[#5a3889] border-[#5a3889]"
                  : "text-gray-400 border-transparent hover:text-[#5a3889]"
              }`}
            >
              Daan Utsav with DLLE St. Andrew's
            </button>
            <button
              onClick={() => setActiveTab("project2")}
              className={`text-lg font-bold transition-all duration-300 pb-2 border-b-4 ${
                activeTab === "project2"
                  ? "text-[#5a3889] border-[#5a3889]"
                  : "text-gray-400 border-transparent hover:text-[#5a3889]"
              }`}
            >
              Museum of Solutions Visit
            </button>
          </div>

          {/* Tab Content */}
          <div className="min-h-[500px]">
            {/* Project 1 Content */}
            {activeTab === "project1" && (
              <FadeIn>
                <div className="space-y-10">
                  
                  {/* Text & Button (Moved Above Images, Text Justified) */}
                  <div className="max-w-4xl mx-auto flex flex-col items-center space-y-6">
                    {/* Added text-justify here */}
                    <p className="text-gray-700 text-lg leading-relaxed text-justify">
                      Kindness Unlimited joined Daan Utsav – India's Festival of Giving (Oct 2–8) in collaboration with DLLE, St. Andrew's College of Arts, Science and Commerce, Bandra, to spread joy and compassion through volunteering. The collected stationery was shared with schools affected by floods through Goonj, reflecting the spirit of community and empathy.
                    </p>
                    <a 
                      href="https://www.instagram.com/p/DPSxFryD8wb/?img_index=1&igsh=aDZ2dmNsZHV2Mm4z" 
                      target="_blank" 
                      rel="noopener noreferrer" 
                      className="inline-flex items-center gap-2 bg-[#5a3889] text-white font-semibold py-3 px-8 rounded-full shadow-md hover:bg-[#472c6e] hover:shadow-lg transition-all"
                    >
                      <i className="fab fa-instagram text-xl"></i> View on Instagram
                    </a>
                  </div>

                  {/* Image Grid */}
                  <div className="space-y-6">
                    {/* Top Row: 3 Images */}
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                      <img className="w-full h-auto rounded-2xl shadow-lg hover:shadow-xl transition-shadow" src={image1} alt="Daan Utsav Event 1" />
                      <img className="w-full h-auto rounded-2xl shadow-lg hover:shadow-xl transition-shadow" src={image2} alt="Daan Utsav Event 2" />
                      <img className="w-full h-auto rounded-2xl shadow-lg hover:shadow-xl transition-shadow" src={image3} alt="Daan Utsav Event 3" />
                    </div>
                    {/* Bottom Row: 2 Images Centered */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:px-32 lg:px-48">
                      <img className="w-full h-auto rounded-2xl shadow-lg hover:shadow-xl transition-shadow" src={image4} alt="Daan Utsav Event 4" />
                      <img className="w-full h-auto rounded-2xl shadow-lg hover:shadow-xl transition-shadow" src={image5} alt="Daan Utsav Event 5" />
                    </div>
                  </div>

                </div>
              </FadeIn>
            )}

            {/* Project 2 Content */}
            {activeTab === "project2" && (
              <FadeIn>
                <div className="grid lg:grid-cols-2 gap-12 items-center">
                  
                  {/* Left: Video */}
                  <div className="w-full flex justify-center">
                    <video className="w-full max-w-md rounded-2xl shadow-xl border-4 border-gray-50" controls>
                      <source src={musoVideo} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  </div>

                  {/* Right: Text & Button */}
                  <div className="space-y-6 flex flex-col items-center lg:items-start">
                    {/* Added text-justify here */}
                    <div className="ku-prose text-gray-700 text-lg leading-relaxed space-y-4 text-justify">
                      <p>
                        Kindness Unlimited, in collaboration with the Museum of Solutions, organized a Daan Utsav event for 160 students from Ramji Assar Gujarati Vidyalaya, Ghatkopar.
                      </p>
                      <p>
                        The initiative, supported by STEM volunteers from St. Andrew's college of Arts, Science and Commerce, Bandra, provided an engaging platform for students to explore, learn, and connect through experiential activities.
                      </p>
                      <p>
                        The event reinforced the value of giving as a means to inspire, educate, and foster meaningful community engagement.
                      </p>
                    </div>
                    
                    <div className="pt-4">
                      <a 
                        href="https://www.instagram.com/reel/DPnlbtcjMnO/?igsh=M2czenV5YzZjODBo" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        className="inline-flex items-center gap-2 bg-[#5a3889] text-white font-semibold py-3 px-8 rounded-full shadow-md hover:bg-[#472c6e] hover:shadow-lg transition-all"
                      >
                        <i className="fab fa-instagram text-xl"></i> View on Instagram
                      </a>
                    </div>
                  </div>

                </div>
              </FadeIn>
            )}
          </div>

        </div>
      </section>
    </PageLayout>
  );
};

export default DaanUtsav;